// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';

import { ArrowRight } from '../../assets/svg/common';
import { Target } from '../../client';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';

export const ExpandButtonClassName = 'expand-button';
const ExpandButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 2em;
  border-radius: 50em;

  background-color: ${theme.ExpandButton.backgroundColor};
  transition: filter 200ms ease-in-out;

  box-sizing: border-box;
  cursor: pointer;

  user-select: none;
  -webkit-tap-highlight-color: transparent;

  ${({ $arrowToRight }) =>
    !Target.__MOBILE__
      ? css`
          &:hover {
            filter: brightness(120%);

            * .expand-arrow-wrapper {
              transform: ${$arrowToRight ? 'translateX(0.1em)' : 'translateX(0)'};
            }
          }
        `
      : undefined}
`;

const ExpandButtonArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.2em;
  transition: transform 200ms ease-in-out;
`;

const StyledArrow = styled(ArrowRight)`
  width: 1.4em;
  height: 0.8em;
  transition: all 150ms ease-in-out;
  transform: ${({ $rotate, $toRight }) =>
    $toRight ? `rotate(0deg) translateX(-1px)` : $rotate ? `rotate(90deg)` : 'rotate(-90deg)'};
  color: ${theme.ExpandButton.titleColor};
`;

const Title = styled.div`
  color: ${theme.ExpandButton.titleColor};
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 0.5em 0 1em;
`;

type PropsType = {
  className?: string;
  isOpen: boolean;
  onClick: () => void;
  expandClickShouldRedirect?: boolean;
};

const ExpandButton = ({
  className = '',
  isOpen = false,
  onClick = () => {},
  expandClickShouldRedirect = false,
}: PropsType) => {
  const onButtonClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    },
    [onClick],
  );

  const label = useMemo(() => {
    if (!isOpen) {
      if (expandClickShouldRedirect) {
        return __('See more selections');
      }
      return __('More selections');
    }
    return __('Less selections');
  }, [expandClickShouldRedirect, isOpen]);

  return (
    <ExpandButtonWrapper
      className={`${ExpandButtonClassName} ${className}`}
      onClick={onButtonClick}
      $arrowToRight={expandClickShouldRedirect}
    >
      <FlexContainer>
        <Title>{label}</Title>
        <ExpandButtonArrowWrapper className="expand-arrow-wrapper">
          <StyledArrow $rotate={!isOpen} $toRight={expandClickShouldRedirect} />
        </ExpandButtonArrowWrapper>
      </FlexContainer>
    </ExpandButtonWrapper>
  );
};

export default ExpandButton;
